var folderTools = require("../platform.files.shared.js");
var normalizeFolderPath = folderTools.normalizeFolderPath;
var joinFolderPath = folderTools.joinFolderPath;
var folderLabel = folderTools.folderLabel;

function esc(value) {
  return (value || "").toString()
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/\"/g, "&quot;")
    .replace(/'/g, "&#39;");
}

function setResult(host, text, isError) {
  if (!(host)) return;
  host.className = isError ? "small text-danger mt-3" : "small text-success mt-3";
  host.textContent = text || "";
}

function folderDisplay(pathValue) {
  var cleaned = normalizeFolderPath(pathValue || "");
  return cleaned ? ("/" + cleaned) : "/";
}

function renderFolderBreadcrumb(pathValue) {
  var cleaned = normalizeFolderPath(pathValue || "");
  var html = "<li class='breadcrumb-item'>" +
    "<button type='button' class='btn btn-link btn-sm p-0 align-baseline text-decoration-none' data-file-breadcrumb-path=''>" +
    "<i class='bi bi-house-door-fill'></i>" +
    "</button>" +
    "</li>";
  if (!(cleaned)) return html;

  var parts = cleaned.split("/");
  var acc = "";
  for (var i = 0; i < parts.length; i++) {
    acc = acc ? (acc + "/" + parts[i]) : parts[i];
    var isActive = i === parts.length - 1;
    if (isActive) {
      html += "<li class='breadcrumb-item active' aria-current='page'>" + esc(parts[i]) + "</li>";
    } else {
      html += "<li class='breadcrumb-item'><button type='button' class='btn btn-link btn-sm p-0 align-baseline text-decoration-none' data-file-breadcrumb-path='" + esc(acc) + "'>" + esc(parts[i]) + "</button></li>";
    }
  }

  return html;
}

function renderReferences(host, refs) {
  if (!(host)) return;
  var rows = refs instanceof Array ? refs : [];

  if (rows.length === 0) {
    host.innerHTML = "<div class='text-muted small'>No references detected.</div>";
    return;
  }

  var html = "<div class='small fw-semibold mb-2'>References (" + rows.length + ")</div>";
  html += "<ul class='small mb-0'>";
  for (var i = 0; i < rows.length; i++) {
    html += "<li><strong>" + esc(rows[i].type || "other") + "</strong>: " + esc(rows[i].path || "") + "</li>";
  }
  html += "</ul>";
  host.innerHTML = html;
}

function actionMessage(payload, fallbackAction) {
  var row = payload && typeof payload === "object" ? payload : {};
  if (row.message) return row.message;
  return "Action completed: " + (row.action || fallbackAction || "update") + ".";
}

function fileActionRedirect(action, payload) {
  var lifecycle = payload && payload.lifecycle ? payload.lifecycle : {};
  if (action === "recycle") return "/dashboard/platform.files.recycle/" + encodeURIComponent((payload.record || {}).id || "");
  if (action === "delete") return "/dashboard/platform.files";
  if (lifecycle && lifecycle.isRecycled) {
    return "/dashboard/platform.files.recycle/" + encodeURIComponent((payload.record || {}).id || "");
  }
  return "";
}

function recycleActionRedirect(action, payload) {
  var lifecycle = payload && payload.lifecycle ? payload.lifecycle : {};
  if (action === "restore") return "/dashboard/platform.files/" + encodeURIComponent((payload.record || {}).id || "");
  if (action === "delete" || (lifecycle && lifecycle.isDeleted)) return "/dashboard/platform.files.recycle";
  return "";
}

async function handleFilesActions(context) {
  var dashboardApi = (context || {}).dashboardApi;
  if (!(dashboardApi)) return;

  var actionResult = document.getElementById("platform-file-action-result");
  var refsHost = document.getElementById("platform-file-references");

  document.querySelectorAll("button[data-file-action]").forEach(function(btn) {
    btn.addEventListener("click", async function() {
      var action = (btn.getAttribute("data-file-action") || "").trim().toLowerCase();
      var fileId = (btn.getAttribute("data-file-id") || "").trim();
      if (!(action) || !(fileId)) return;

      if (action === "recycle") {
        var okRecycle = window.confirm("Send this file to recycling? This keeps it recoverable for 60 days.");
        if (!okRecycle) return;
      }

      if (action === "delete") {
        var okDelete = window.confirm("Permanently delete this file? This cannot be undone.");
        if (!okDelete) return;
      }

      if (action === "privacy") {
        var okPrivacy = window.confirm("Preserve Privacy will remove metadata that may affect appearance, licensing, or file behavior. Continue with caution.");
        if (!okPrivacy) return;
      }

      try {
        var response = await dashboardApi.action("platform.files", "action", {
          action: action,
          fileId: fileId
        });

        if (!(response && response.success)) {
          var errorItem = (response && response.errors && response.errors[0]) || {};
          setResult(actionResult, errorItem.description || "Action failed.", true);
          return;
        }

        var payload = response.data || {};
        var nextUrl = fileActionRedirect(action, payload);
        var nextMessage = actionMessage(payload, action);
        if (action === "recycle" && nextUrl) {
          nextMessage += " Opening recycle detail…";
        } else if (action === "delete" && nextUrl) {
          nextMessage += " Returning to file manager…";
        }
        setResult(actionResult, nextMessage, false);

        renderReferences(refsHost, payload.references || ((payload.record || {}).references) || []);

        if (nextUrl) {
          setTimeout(function() {
            window.location.href = nextUrl;
          }, 700);
        }
      } catch (error) {
        console.error("platform.files action failed", error);
        setResult(actionResult, (error && error.message) || "Action failed.", true);
      }
    });
  });
}

async function handleRecycleActions(context) {
  var dashboardApi = (context || {}).dashboardApi;
  if (!(dashboardApi)) return;

  var resultHost = document.getElementById("platform-recycle-action-result");

  document.querySelectorAll("button[data-recycle-action]").forEach(function(btn) {
    btn.addEventListener("click", async function() {
      var action = (btn.getAttribute("data-recycle-action") || "").trim().toLowerCase();
      var fileId = (btn.getAttribute("data-file-id") || "").trim();
      if (!(action) || !(fileId)) return;

      if (action === "restore") {
        var okRestore = window.confirm("Restore this file to its previous workspace and open it in the file manager?");
        if (!okRestore) return;
      }

      if (action === "delete") {
        var okDelete = window.confirm("Permanently delete this recycled file? This cannot be undone.");
        if (!okDelete) return;
      }

      try {
        var response = await dashboardApi.action("platform.files.recycle", "action", {
          action: action,
          fileId: fileId
        });

        if (!(response && response.success)) {
          var errItem = (response && response.errors && response.errors[0]) || {};
          setResult(resultHost, errItem.description || "Action failed.", true);
          return;
        }

        var payload = response.data || {};
        var nextUrl = recycleActionRedirect(action, payload);
        var nextMessage = actionMessage(payload, action);
        if (action === "restore" && nextUrl) {
          nextMessage += " Opening restored file…";
        } else if (action === "delete" && nextUrl) {
          nextMessage += " Returning to recycle list…";
        }
        setResult(resultHost, nextMessage, false);
        if (nextUrl) {
          setTimeout(function() {
            window.location.href = nextUrl;
          }, 700);
        }
      } catch (error) {
        console.error("platform.files.recycle action failed", error);
        setResult(resultHost, (error && error.message) || "Action failed.", true);
      }
    });
  });
}

function renderPartUpdate(query, inner) {
  if (!(window.UATools && typeof window.UATools.PerformResponse === "function")) return false;
  window.UATools.PerformResponse({
    n: "part",
    query: query,
    i: inner
  });
  return true;
}

function refreshDashboardList(listHost, filters) {
  if (!(listHost)) return;
  listHost.dispatchEvent(new CustomEvent("ua:dashboard:list:reload", {
    bubbles: true,
    detail: {
      filters: filters || {}
    }
  }));
}

function shouldRefreshForUploadedFolder(viewFolder, uploadedFolder) {
  var view = normalizeFolderPath(viewFolder || "");
  var uploaded = normalizeFolderPath(uploadedFolder || "");
  if (!(uploaded)) return !(view);
  if (!(view)) return true;
  if (uploaded === view) return true;
  return uploaded.indexOf(view + "/") === 0;
}

async function handleFinder(context) {
  var dashboardApi = (context || {}).dashboardApi;
  if (!(dashboardApi)) return;

  var finderRoot = document.querySelector("[data-platform-files-finder]");
  if (!(finderRoot)) return;

  var currentFolderLabel = document.getElementById("platform-files-current-folder");
  var folderNewInput = finderRoot.querySelector("[data-file-folder-new]");
  var folderAddBtn = finderRoot.querySelector("[data-file-folder-add]");
  var folderRemoveBtn = finderRoot.querySelector("[data-file-folder-remove]");
  var uploadHost = finderRoot.querySelector("[data-ua-file-upload-name='platform-files-upload']");
  var listHost = finderRoot.querySelector("[data-ua-dashboard-list][data-dashboard-page-namespace='platform.files']");
  var folderFilterControl = listHost ? listHost.querySelector("[data-dashboard-filter='folder']") : null;
  var scopeFilterSelect = listHost ? listHost.querySelector("[data-dashboard-filter='scope']") : null;
  var uploadStatusHost = document.getElementById("platform-files-upload-status");
  var folderStatusHost = document.getElementById("platform-files-folder-status");
  var folderListHost = finderRoot.querySelector("[data-file-folder-list='true']");
  var activeFolder = "";

  function setMessageOnHost(selector, host, text, isError, className) {
    var msg = (text || "").toString().trim();
    if (renderPartUpdate(selector, msg)) {
      var nextHost = document.querySelector(selector);
      if (nextHost) nextHost.className = className + " " + (isError ? "text-danger" : "text-muted") + (msg ? "" : " d-none");
      return;
    }
    if (!(host)) return;
    host.className = className + " " + (isError ? "text-danger" : "text-muted") + (msg ? "" : " d-none");
    host.textContent = msg;
  }

  function setFolderStatus(text, isError) {
    setMessageOnHost("#platform-files-folder-status", folderStatusHost, text, isError, "small mb-2");
  }

  function setUploadStatus(text, isError) {
    setMessageOnHost("#platform-files-upload-status", uploadStatusHost, text, isError, "small mb-2");
  }

  function getKnownFolders() {
    var seen = { "": true };
    var rows = [""];

    if (folderListHost) {
      folderListHost.querySelectorAll("button[data-file-folder-path]").forEach(function(btn) {
        var pathValue = normalizeFolderPath(btn.getAttribute("data-file-folder-path") || "");
        if (seen[pathValue]) return;
        seen[pathValue] = true;
        rows.push(pathValue);
      });
    }

    if (folderFilterControl && folderFilterControl.tagName === "SELECT") {
      folderFilterControl.querySelectorAll("option").forEach(function(option) {
        var pathValue = normalizeFolderPath(option.value || "");
        if (seen[pathValue]) return;
        seen[pathValue] = true;
        rows.push(pathValue);
      });
    }

    rows.sort(function(a, b) {
      if (a === "") return -1;
      if (b === "") return 1;
      return a.localeCompare(b);
    });

    return rows;
  }

  function renderFolderButton(pathValue) {
    var normalized = normalizeFolderPath(pathValue || "");
    var depth = normalized ? normalized.split("/").length : 0;
    var btn = document.createElement("button");
    btn.type = "button";
    btn.className = "btn btn-sm btn-outline-secondary text-start w-100";
    btn.style.paddingLeft = (0.65 + (depth * 0.8)) + "rem";
    btn.setAttribute("data-file-folder-path", normalized);
    btn.innerHTML = "<i class='" + (normalized ? "bi bi-folder me-1" : "bi bi-house-door me-1") + "'></i>" + esc(normalized ? folderLabel(normalized) : "Root");
    return btn;
  }

  function renderFolderOptions(paths) {
    if (!(folderFilterControl) || folderFilterControl.tagName !== "SELECT") return;
    var activeValue = normalizeFolderPath(folderFilterControl.value || activeFolder || "");
    folderFilterControl.innerHTML = "";

    var rows = paths instanceof Array ? paths : [];
    for (var i = 0; i < rows.length; i++) {
      var pathValue = normalizeFolderPath(rows[i] || "");
      var option = document.createElement("option");
      option.value = pathValue;
      option.textContent = pathValue ? ("/" + pathValue) : "/";
      folderFilterControl.appendChild(option);
    }

    folderFilterControl.value = activeValue;
  }

  function renderFolderButtons(paths) {
    if (!(folderListHost)) return;
    folderListHost.innerHTML = "";
    var rows = paths instanceof Array ? paths : [];
    for (var i = 0; i < rows.length; i++) {
      folderListHost.appendChild(renderFolderButton(rows[i] || ""));
    }
  }

  function replaceKnownFolders(paths) {
    var next = { "": true };
    var ordered = [""];
    var rows = paths instanceof Array ? paths : [];
    for (var i = 0; i < rows.length; i++) {
      var pathValue = normalizeFolderPath(rows[i] || "");
      if (next[pathValue]) continue;
      next[pathValue] = true;
      ordered.push(pathValue);
    }
    ordered.sort(function(a, b) {
      if (a === "") return -1;
      if (b === "") return 1;
      return a.localeCompare(b);
    });
    renderFolderButtons(ordered);
    renderFolderOptions(ordered);
    markActiveFolder(activeFolder);
  }

  function mutateKnownFolders(mutator) {
    var current = getKnownFolders();
    var next = typeof mutator === "function" ? mutator(current.slice()) : current.slice();
    replaceKnownFolders(next);
  }

  function renameKnownFolders(sourcePath, targetPath) {
    var source = normalizeFolderPath(sourcePath || "");
    var target = normalizeFolderPath(targetPath || "");
    mutateKnownFolders(function(paths) {
      return paths.map(function(pathValue) {
        var current = normalizeFolderPath(pathValue || "");
        if (!(current)) return "";
        if (current === source) return target;
        if (current.indexOf(source + "/") === 0) return target + current.slice(source.length);
        return current;
      });
    });
  }

  function removeKnownFolders(pathsToRemove) {
    var targets = (pathsToRemove instanceof Array ? pathsToRemove : []).map(function(pathValue) {
      return normalizeFolderPath(pathValue || "");
    }).filter(Boolean);

    mutateKnownFolders(function(paths) {
      return paths.filter(function(pathValue) {
        var current = normalizeFolderPath(pathValue || "");
        if (!(current)) return true;
        return targets.indexOf(current) < 0;
      });
    });
  }

  function addKnownFolder(pathValue) {
    var normalized = normalizeFolderPath(pathValue || "");
    if (!(normalized)) return;
    var parts = normalized.split("/");
    mutateKnownFolders(function(paths) {
      for (var i = 0; i < parts.length; i++) {
        var nextPath = parts.slice(0, i + 1).join("/");
        paths.push(nextPath);
      }
      return paths;
    });
  }

  function markActiveFolder(pathValue) {
    var activePath = normalizeFolderPath(pathValue || "");
    if (folderListHost) {
      folderListHost.querySelectorAll("button[data-file-folder-path]").forEach(function(btn) {
        var btnPath = normalizeFolderPath(btn.getAttribute("data-file-folder-path") || "");
        var isActive = btnPath === activePath;
        btn.classList.toggle("btn-primary", isActive);
        btn.classList.toggle("btn-outline-secondary", !isActive);
      });
    }
  }

  function updateRemoveButtonState(pathValue) {
    if (!(folderRemoveBtn)) return;
    var disabled = !(normalizeFolderPath(pathValue || ""));
    folderRemoveBtn.disabled = disabled;
    folderRemoveBtn.classList.toggle("disabled", disabled);
    folderRemoveBtn.setAttribute("aria-disabled", disabled ? "true" : "false");
    folderRemoveBtn.setAttribute("title", disabled
      ? "Root folder cannot be removed"
      : "Send current folder files to recycling and remove folder");
  }

  function pushFolderToUploader(pathValue) {
    if (!(uploadHost)) return;
    uploadHost.dispatchEvent(new CustomEvent("ua:fileupload:setfolder", {
      bubbles: true,
      detail: { folder: normalizeFolderPath(pathValue || "") }
    }));
  }

  function setFolder(pathValue, options) {
    var opts = options || {};
    var normalized = normalizeFolderPath(pathValue || "");
    activeFolder = normalized;

    if (currentFolderLabel) {
      currentFolderLabel.innerHTML = renderFolderBreadcrumb(normalized);
    }

    if (folderFilterControl && folderFilterControl.tagName === "SELECT") {
      folderFilterControl.value = normalized;
    }

    markActiveFolder(normalized);
    updateRemoveButtonState(normalized);
    pushFolderToUploader(normalized);

    if (opts.updateUrl !== false) {
      var url = new URL(window.location.href);
      if (normalized) url.searchParams.set("folder", normalized);
      else url.searchParams.delete("folder");
      window.history.replaceState({}, "", url.toString());
    }

    if (opts.refreshList === true) {
      refreshDashboardList(listHost, {
        folder: normalized,
        scope: "content"
      });
    }
  }

  function goToFolder(pathValue, refreshList) {
    defaultScopeContent();
    setFolder(pathValue, {
      updateUrl: true,
      refreshList: refreshList !== false
    });
  }

  function defaultScopeContent() {
    if (!(scopeFilterSelect)) return;
    if ((scopeFilterSelect.value || "").toString().trim().toLowerCase() === "content") return;
    scopeFilterSelect.value = "content";
    scopeFilterSelect.dispatchEvent(new Event("change", { bubbles: true }));
  }

  function fallbackFolder(pathValue) {
    var normalized = normalizeFolderPath(pathValue || "");
    if (!(normalized)) return "";
    var folders = getKnownFolders();
    var lookup = {};
    for (var i = 0; i < folders.length; i++) lookup[folders[i]] = true;

    var probe = normalized;
    while (probe) {
      if (lookup[probe]) return probe;
      var parts = probe.split("/");
      parts.pop();
      probe = parts.join("/");
    }
    return "";
  }

  function normalizeRelativeFolderInput(raw) {
    var typed = normalizeFolderPath(raw || "");
    if (!(typed)) return "";
    return joinFolderPath(activeFolder, typed);
  }

  finderRoot.addEventListener("click", function(event) {
    var folderBtn = event.target.closest("button[data-file-folder-path]");
    if (folderBtn && finderRoot.contains(folderBtn)) {
      event.preventDefault();
      goToFolder(folderBtn.getAttribute("data-file-folder-path") || "", true);
      return;
    }

    var crumbBtn = event.target.closest("button[data-file-breadcrumb-path]");
    if (crumbBtn && currentFolderLabel && currentFolderLabel.contains(crumbBtn)) {
      event.preventDefault();
      goToFolder(crumbBtn.getAttribute("data-file-breadcrumb-path") || "", true);
      return;
    }

    var renameBtn = event.target.closest("button[data-file-folder-row-rename='true']");
    if (renameBtn && listHost && listHost.contains(renameBtn)) {
      event.preventDefault();
      event.stopPropagation();
      handleFolderRename(renameBtn);
      return;
    }

    var removeBtn = event.target.closest("button[data-file-folder-row-remove='true']");
    if (removeBtn && listHost && listHost.contains(removeBtn)) {
      event.preventDefault();
      event.stopPropagation();
      handleFolderRemove(normalizeFolderPath(removeBtn.getAttribute("data-folder-path") || ""));
      return;
    }

    var folderTarget = event.target.closest("[data-file-folder-nav='true']");
    if (folderTarget && listHost && listHost.contains(folderTarget)) {
      var folderPath = normalizeFolderPath(folderTarget.getAttribute("data-folder-path") || "");
      if (folderPath || folderTarget.getAttribute("data-folder-path") === "") {
        event.preventDefault();
        event.stopPropagation();
        goToFolder(folderPath, true);
      }
    }
  });

  async function handleFolderRemove(pathValue) {
    var currentPath = normalizeFolderPath(pathValue || activeFolder || "");
    if (!(currentPath)) {
      setFolderStatus("Root folder cannot be removed.", true);
      return;
    }

    var ok = window.confirm("Send folder '" + currentPath + "' and its files to recycling, then remove this folder?");
    if (!ok) return;

    try {
      var response = await dashboardApi.action("platform.files", "action", {
        action: "folder.remove",
        scope: "content",
        path: currentPath
      });

      if (!(response && response.success)) {
        var err = (response && response.errors && response.errors[0]) || {};
        setFolderStatus(err.description || "Could not remove folder.", true);
        return;
      }

      var payload = response.data || {};
      var removed = payload.removed || {};
      var removedPaths = (removed.removedPaths instanceof Array ? removed.removedPaths : [])
        .map(function(pathItem) { return normalizeFolderPath(pathItem || ""); })
        .filter(Boolean);

      if (removedPaths.length === 0 && currentPath) removedPaths = [currentPath];
      removeKnownFolders(removedPaths);

      var nextFolder = fallbackFolder(activeFolder);
      setFolder(nextFolder, {
        updateUrl: true,
        refreshList: true
      });

      var recycledCount = Number(payload.recycledCount || 0);
      var removedCount = Number(removed.removedCount || removedPaths.length || 1);
      setFolderStatus("Folder removed: /" + currentPath + ". Removed " + removedCount + " folder(s) and recycled " + recycledCount + " file(s).", false);
    } catch (error) {
      console.error("platform.files folder.remove failed", error);
      setFolderStatus((error && error.message) || "Could not remove folder.", true);
    }
  }

  async function handleFolderRename(btn) {
    var currentPath = normalizeFolderPath(btn.getAttribute("data-folder-path") || "");
    if (!(currentPath)) return;

    var currentName = currentPath.split("/").pop() || currentPath;
    var nextName = window.prompt("Rename folder", currentName);
    if (nextName === null) return;

    var cleanedName = normalizeFolderPath(nextName || "").split("/").pop() || "";
    if (!(cleanedName)) {
      setFolderStatus("Enter a valid folder name.", true);
      return;
    }

    try {
      var response = await dashboardApi.action("platform.files", "action", {
        action: "folder.rename",
        scope: "content",
        path: currentPath,
        newName: cleanedName
      });

      if (!(response && response.success)) {
        var err = (response && response.errors && response.errors[0]) || {};
        setFolderStatus(err.description || "Could not rename folder.", true);
        return;
      }

      var payload = response.data || {};
      var renamed = payload.renamed || {};
      var fromPath = normalizeFolderPath(renamed.from || currentPath);
      var toPath = normalizeFolderPath(renamed.to || joinFolderPath(currentPath.split("/").slice(0, -1).join("/"), cleanedName));

      renameKnownFolders(fromPath, toPath);

      var nextActive = activeFolder;
      if (nextActive === fromPath) nextActive = toPath;
      else if (nextActive.indexOf(fromPath + "/") === 0) nextActive = toPath + nextActive.slice(fromPath.length);

      setFolder(nextActive, {
        updateUrl: true,
        refreshList: true
      });

      setFolderStatus("Folder renamed: " + folderDisplay(fromPath) + " → " + folderDisplay(toPath) + ".", false);
    } catch (error) {
      console.error("platform.files folder.rename failed", error);
      setFolderStatus((error && error.message) || "Could not rename folder.", true);
    }
  }

  if (folderAddBtn) {
    folderAddBtn.addEventListener("click", async function() {
      var raw = folderNewInput ? folderNewInput.value : "";
      var pathValue = normalizeRelativeFolderInput(raw || "");
      if (!(pathValue)) {
        setFolderStatus("Enter a valid folder name relative to the current folder.", true);
        return;
      }

      try {
        var response = await dashboardApi.action("platform.files", "action", {
          action: "folder.upsert",
          scope: "content",
          path: pathValue,
          title: pathValue.split("/").pop() || pathValue
        });

        if (!(response && response.success)) {
          var err = (response && response.errors && response.errors[0]) || {};
          setFolderStatus(err.description || "Could not create folder.", true);
          return;
        }

        if (folderNewInput) folderNewInput.value = "";
        addKnownFolder(pathValue);
        setFolder(pathValue, {
          updateUrl: true,
          refreshList: true
        });
        setFolderStatus("Folder ready: " + folderDisplay(pathValue), false);
      } catch (error) {
        console.error("platform.files folder.upsert failed", error);
        setFolderStatus((error && error.message) || "Could not create folder.", true);
      }
    });
  }

  if (folderRemoveBtn) {
    folderRemoveBtn.addEventListener("click", async function() {
      await handleFolderRemove(activeFolder);
    });
  }

  if (folderFilterControl) {
    folderFilterControl.addEventListener("change", function() {
      if ((scopeFilterSelect && (scopeFilterSelect.value || "").toString().trim().toLowerCase() === "secured")) return;
      setFolder(folderFilterControl.value || "", {
        updateUrl: true,
        refreshList: false
      });
    });
  }

  if (scopeFilterSelect) {
    scopeFilterSelect.addEventListener("change", function() {
      var nextScope = (scopeFilterSelect.value || "").toString().trim().toLowerCase();
      if (nextScope === "content") {
        setFolder(activeFolder, {
          updateUrl: true,
          refreshList: false
        });
      }
    });
  }

  if (listHost) {
    listHost.addEventListener("ua:dashboard:list:reload", function(event) {
      var detail = (event || {}).detail || {};
      var filters = detail.filters || {};
      var scopeValue = (filters.scope || (scopeFilterSelect ? scopeFilterSelect.value : "") || "").toString().trim().toLowerCase();
      if (scopeValue === "content" || !(scopeValue)) {
        setFolder(filters.folder || activeFolder || "", {
          updateUrl: true,
          refreshList: false
        });
      }
    });
  }

  var currentFromUrl = normalizeFolderPath((new URL(window.location.href)).searchParams.get("folder") || "");
  defaultScopeContent();
  replaceKnownFolders(getKnownFolders());
  setFolder(fallbackFolder(currentFromUrl), {
    updateUrl: true,
    refreshList: true
  });

  if (uploadHost) {
    uploadHost.addEventListener("ua:fileupload:complete", function(event) {
      var detail = (event || {}).detail || {};
      var item = detail.item || {};
      var record = detail.record || {};
      var uploadFolder = normalizeFolderPath(item.folder || record.folder || "");
      if (uploadFolder) addKnownFolder(uploadFolder);

      if (shouldRefreshForUploadedFolder(activeFolder, uploadFolder)) {
        refreshDashboardList(listHost, {
          folder: normalizeFolderPath(activeFolder || ""),
          scope: "content"
        });
      }
    });

    uploadHost.addEventListener("ua:fileupload:batchcomplete", function(event) {
      var detail = (event || {}).detail || {};
      var rows = (detail.items instanceof Array) ? detail.items : [];
      var completed = rows.filter(function(item) { return item.status === "complete"; });
      var failed = rows.filter(function(item) { return item.status === "error" || item.status === "lost"; });

      if (failed.length > 0) {
        var firstFailure = failed[0] || {};
        setUploadStatus("Upload issue: " + (firstFailure.message || firstFailure.status || "Failed upload."), true);
      } else if (completed.length > 0) {
        setUploadStatus("Upload complete: " + completed.length + " file(s).", false);
      }

      for (var i = 0; i < completed.length; i++) {
        var uploadFolder = normalizeFolderPath(completed[i].folder || (((completed[i].record || {}).folder) || ""));
        if (uploadFolder) addKnownFolder(uploadFolder);
      }

      var uploadedToCurrentFolder = completed.some(function(item) {
        var itemFolder = normalizeFolderPath(item.folder || (((item.record || {}).folder) || ""));
        return shouldRefreshForUploadedFolder(activeFolder, itemFolder);
      });

      if (uploadedToCurrentFolder) {
        refreshDashboardList(listHost, {
          folder: normalizeFolderPath(activeFolder || ""),
          scope: "content"
        });
      }
    });
  }
}

module.exports = async function(context) {
  var ns = ((((context || {}).dashboard || {}).currentPage || {}).namespace || "").toString();

  if (ns === "platform.files") {
    await handleFinder(context);
    await handleFilesActions(context);
    return;
  }

  if (ns === "platform.files.recycle") {
    await handleRecycleActions(context);
  }
};
